var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-hover table-sm mt-1" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.list, function (t, i) {
          return _c("tr", [
            _c("td", [_vm._v(_vm._s(i + 1))]),
            _vm._v(" "),
            _c("td", [
              _c("p", [_vm._v(_vm._s(t.task_data.created_by_name))]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(
                  _vm._s(_vm.printDate(t.created_at)) +
                    " (" +
                    _vm._s(t.id) +
                    ")"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("p", [_vm._v(_vm._s(t.order.address))]),
              _vm._v(" "),
              t.order.extra_options.address_details
                ? _c("p", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(t.order.extra_options.address_details)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("td", [
              _c("p", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-xs btn-info mr-1",
                    on: {
                      click: function ($event) {
                        return _vm.orderToEdit(t.order_id)
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                ),
                _vm._v("\n          " + _vm._s(t.order_id) + "\n        "),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("установлено: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.orderSalaryRates[t.task_data.old_value])),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("запрос: "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.orderSalaryRates[t.task_data.new_value])),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("td", [
              t.task_data.message
                ? _c("div", {
                    domProps: { innerHTML: _vm._s(t.task_data.message) },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("td", [
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: '<i class="icon-fa icon-fa-check"></i>',
                      className: "btn btn-success btn-xs mr-1",
                      onClick: () => _vm.updateRequest(t.id, "acceptAndClose"),
                      loading: _vm.btnLoading[t.id],
                      color: "white",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-popover",
                    { attrs: { "auto-hide": true, placement: "left" } },
                    [
                      _c("button", { staticClass: "btn btn-xs btn-danger" }, [
                        _c("i", { staticClass: "icon-fa icon-fa-close" }),
                      ]),
                      _vm._v(" "),
                      _c("template", { slot: "popover" }, [
                        _c("div", { staticClass: "p-2" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Причина отказа запроса"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.rejectComment[t.id],
                                  expression: "rejectComment[t.id]",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                placeholder: "Причина отказа запроса",
                                type: "text",
                              },
                              domProps: { value: _vm.rejectComment[t.id] },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.rejectComment,
                                    t.id,
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-right" },
                            [
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Подтвердить отказ",
                                  className:
                                    "btn btn-outline-warning btn-xs mr-1",
                                  onClick: () =>
                                    _vm.updateRequest(t.id, "rejectRequest"),
                                  loading: _vm.btnLoading[t.id],
                                  color: _vm.$constants.WARNING_COLOR,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Курьер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("th", [_vm._v("Запрос")]),
        _vm._v(" "),
        _c("th", [_vm._v("Текст")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }